import { Button } from "components/primitives";
import styled from "styled-components";

export const ToolbarHeaderButton = styled(Button)`
  background-color: var(--primary);
  color: black;
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  font-weight: 600;
  font-size: 9pt;
  box-shadow: none;
`;
